"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Consumer = exports.Provider = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var LanguageContext = (0, _react.createContext)();
var Consumer = LanguageContext.Consumer;
exports.Consumer = Consumer;

var Provider = function Provider(_ref) {
  var children = _ref.children,
      _ref$location = _ref.location;
  _ref$location = _ref$location === void 0 ? {} : _ref$location;
  var pathname = _ref$location.pathname,
      search = _ref$location.search,
      hash = _ref$location.hash,
      availableLanguages = _ref.availableLanguages,
      _ref$alternativeLangu = _ref.alternativeLanguages,
      alternativeLanguages = _ref$alternativeLangu === void 0 ? [] : _ref$alternativeLangu,
      _ref$onUpdate = _ref.onUpdate,
      onUpdate = _ref$onUpdate === void 0 ? function (_ref6) {
    var lang = _ref6.lang,
        prevLang = _ref6.prevLang,
        url = _ref6.url,
        prevURL = _ref6.prevURL;
  } : _ref$onUpdate,
      _ref$persistLang = _ref.persistLang,
      persistLang = _ref$persistLang === void 0 ? true : _ref$persistLang,
      _ref$useNavigator = _ref.useNavigator,
      useNavigator = _ref$useNavigator === void 0 ? true : _ref$useNavigator,
      _ref$useURL = _ref.useURL,
      useURL = _ref$useURL === void 0 ? true : _ref$useURL;

  var _useState = (0, _react.useState)(resolveLanguage(getDefaultLanguage())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      lang = _useState2[0],
      setLanguage = _useState2[1];
  /**
   * Persists language key to local storage when persistLang is true
   *
   * @param {String} language The language to persist to local storage
   * @returns {Void}
   */


  function persistToLocalStorage(language) {
    if (persistLang) global.window && global.window.localStorage && global.window.localStorage.setItem('lang', language);
  }
  /**
   * Fetches an initial default language going through all possible sources as follows
   *   - url
   *   - local storage
   *   - navigator
   *   - first language in availableLanguages
   *
   * @returns {String} Language key
   */


  function getDefaultLanguage() {
    var urlLang = useURL ? getURLLang() : ''; // Use URL language where available

    if (isValidLanguage(urlLang)) return urlLang; // Fallback to local storage or default config

    var localStorageLang = persistLang && global.window && global.window.localStorage && global.window.localStorage.getItem('lang') || ''; // Users browser language

    var navigatorLanguage = (useNavigator && global.window && global.window.navigator && global.window.navigator.language || '').substring(0, 2); // Use local storage first as they have already visited the site

    if (isValidLanguage(localStorageLang)) return localStorageLang; // Use the users browser language if it supported by the site

    if (isValidLanguage(navigatorLanguage)) return navigatorLanguage; // Fall back to the first available language in the config

    return availableLanguages[0].key;
  }
  /**
   * Resolves any potential language from alternativeLanguages to availableLanguages
   *
   * @param {String} lang Language key
   * @returns {String} Language key
   */


  function resolveLanguage(lang) {
    var filteredAlternativeLanguages = alternativeLanguages.filter(function (_ref2) {
      var key = _ref2.key;
      return key === lang;
    });
    if (filteredAlternativeLanguages.length > 0) return filteredAlternativeLanguages.shift().languageKey;
    return lang;
  }
  /**
   * Fetches the language object for a specific key from availableLanguages
   * or resolves from alternativeLanguages
   *
   * @param {String} language Language key
   * @returns {<Object|undefined>}
   */


  function getLanguage(language) {
    var lang = availableLanguages.filter(function (_ref3) {
      var key = _ref3.key;
      return key === language;
    }).shift();
    if (!lang) language = (alternativeLanguages.filter(function (_ref4) {
      var key = _ref4.key;
      return key === language;
    }).shift() || {}).languageKey;
    return lang || availableLanguages.filter(function (_ref5) {
      var key = _ref5.key;
      return key === language;
    }).shift();
  }
  /**
   * Checks is a language key is valid, i.e. is valid from availableLanguages
   * or alternativeLanguages
   *
   * @param {String} language Language key
   * @returns {Boolean}
   */


  function isValidLanguage(language) {
    return Boolean(getLanguage(language));
  }
  /**
   * Fetches the possible language from the URL
   *
   * @returns {String}
   */


  function getURLLang() {
    return pathname.split('/').splice(1)[0] || '';
  }
  /**
   * Checks if the language from the URL is a valid language
   *
   * @returns {Boolean}
   */


  function languageSetInURL() {
    return isValidLanguage(getURLLang());
  }
  /**
   * Builds the URL for a particular language
   *
   * @param {String} language Language key
   * @returns {String}
   */


  function getURL(language) {
    var pathParts = pathname.split('/').splice(1);

    if (languageSetInURL()) {
      pathParts.splice(0, 1, language);
    } else {
      pathParts.unshift(language);
    }

    return "/".concat(pathParts.filter(function (part) {
      return Boolean(part);
    }).join('/').replace(/\/{2,}/g, '/'), "/").concat(search).concat(hash);
  }

  (0, _react.useEffect)(function () {
    persistToLocalStorage(lang);
    var updateArgs = {
      lang: lang,
      prevLang: null
    };

    if (useURL) {
      updateArgs.url = getURL(lang);
      updateArgs.prevURL = null;
    }

    onUpdate(updateArgs);
  }, []);
  /**
   * Runs through all steps when updating the language
   *
   * @param {String} language Language key
   * @returns {Void}
   */

  function setLang(language) {
    if (!isValidLanguage(language)) throw new Error("Invalid language ".concat(language));
    persistToLocalStorage(language);
    var updateArgs = {
      lang: language,
      prevLang: lang
    };

    if (useURL) {
      updateArgs.url = getURL(language);
      updateArgs.prevURL = "".concat(pathname).concat(search).concat(hash);
    }

    onUpdate(updateArgs);
    setLanguage(language);
  }

  return _react["default"].createElement(LanguageContext.Provider, {
    value: {
      key: lang,
      setLang: setLang,
      locale: getLanguage(lang).locale,
      flag: getLanguage(lang).flag,
      label: getLanguage(lang).label,
      availableLanguages: availableLanguages,
      alternativeLanguages: alternativeLanguages
    }
  }, children);
};

exports.Provider = Provider;
Provider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  location: function location(props, propName, componentName) {
    var requiredKeys = ['pathname', 'search', 'hash'];

    if (props.useURL && (!props[propName] || (0, _typeof2["default"])(props[propName]) !== 'object' || Array.isArray(props[propName]))) {
      return new Error("When 'useURL' is true, location must be provided as an object with location.pathname, location.search and location.hash");
    } else if (props.useURL) {
      while (requiredKeys.length > 0) {
        var key = requiredKeys.shift();
        if (typeof props[propName][key] !== 'string') return new Error("location.".concat(key, " must be a string"));
      }
    }
  },
  availableLanguages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    flag: _propTypes["default"].string,
    locale: _propTypes["default"].string.isRequired
  })).isRequired,
  alternativeLanguages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    languageKey: _propTypes["default"].string.isRequired
  })),
  onUpdate: _propTypes["default"].func,
  persistLang: _propTypes["default"].bool,
  useNavigator: _propTypes["default"].bool,
  useURL: _propTypes["default"].bool
};
var _default = {
  Provider: Provider,
  Consumer: Consumer
};
exports["default"] = _default;